export default "__VITE_ASSET__CmqmI0Yv__"